import React, { useState } from 'react'
import { circleList, figma, XD, invision, protopie, ps, illustrator, miro } from '../../assets/images'
import styles from './Resume.module.css'
interface Props{
  effect:string
}
const Resume = (props:Props) => {
  // const [textIndex, setIndex] = useState(0)


  // setTimeout(() => {

  //   setIndex(textIndex + 1)

  // }, 200)

  const resumeInfos = [{
    text: "  I am a Detailed oriented user-centric designer, with over 2 years of experience in delivering pixel-perfect design mockups and solutions. I possess a keen eye for quality  design solutions, which I have honed from other projects, which I have worked on during my boot camps, freelance, and other internships.",
    header: "professional experience"
  }, {
    text: " User Research,  Information Architecture,  Empathy Mapping, Wireframing,  Prototyping,  User flows and User Journey Mapping,  Visual Design,  Sitemaps,  Storyboarding,  Agile Methodologies.",
    header: "skills"
  }
  ]

  const tools: { img: any; name: string }[] = [
    {
      img: figma,
      name: "figma",
    }, {
      img: miro,
      name: "miro",
    },
    {
      img: invision,
      name: "invision",
    },
    {
      img: protopie,
      name: "protopie",
    },
    {
      img: ps,
      name: "photoshop",
    },
    {
      img: illustrator,
      name: "illustrator",
    },
    {
      img: XD,
      name: "adobe XD",
    }
  ]


  return (
    <section id='Resume'  className='text-white md:mb-[9.938rem] mb-[3.313rem] md:mt-[6.75rem] mt-[2.75rem]'>
      <header className='text-center  text-[1.125rem] lg:text-[2.25rem] bold uppercase text-[#A6B2EC] mb-[2.527rem] '>resume</header>
      <div className='container  md:pl-[61px] md:pr-[57px] p-[20px]'>
        <div>
          <ul className='relative'>

            <div className={`fadedCircle absolute z-[-1] lg:top-[80%] lg:block hidden top-[40%] right-0 lg:left-[0%] bg-[#FE0000] rounded-full `}></div>
            <div className={`fadedCircle absolute lg:top-[100%] top-[5%] lg:block hidden  left-[50%]  lg:left-[-10%] z-[-1] bg-[#3971E7] rounded-full `}></div>


            <div className={`fadedCircle absolute z-[-1] lg:top-[-30%] top-[40%] right-0 lg:left-[5%] bg-[#FE0000] rounded-full `}></div>
            <div className={`circle absolute lg:top-[-50%] top-[5%] left-[50%] translate-x-[-50%]  lg:left-[-2%] z-[-1] bg-[#3971E7] rounded-full `}></div>


            {/* <img src={circleList} className="inline mr-[15px]" alt="" /> */}
            {resumeInfos.map((resumeInfo, index) => (
              <li data-aos={props.effect} key={index} className={` ${styles.li}  mt-5 lg:text-[1.5rem] mb-[2.75rem]`}>
                <span className='ml-[15px] capitalize'>{resumeInfo.header}</span>
                <p className='text-center sm:text-left  light text-[0.75rem] lg:text-[1.125rem] mt-[1rem] leading-[2.188rem]'>
                  {resumeInfo.text}
                </p>
              </li>
            ))}
            <li className={`${styles.li} relative capitalize lg:text-[1.5rem]`}>

              <span className='pl-[15px]'>tools</span>
              <div className='flex flex-wrap gap-5 sm:gap-0 lg:justify-start justify-evenly'>
                {tools.map((tool: any, index: number) => (<img key={index} className="lg:mr-[4.5rem] my-5" src={tool.img} alt={tool.name} />))}

              </div>


            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Resume